import { render, staticRenderFns } from "./boton_imprimir.vue?vue&type=template&id=21f1186a&lang=pug&"
import script from "./boton_imprimir.vue?vue&type=script&lang=js&"
export * from "./boton_imprimir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports